/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import Header from "../../Containers/Header";
import { Link } from "react-router-dom";
import { languageJson } from "../../StringVariable";
import "./eri.css";
import { GET_DATAHUB_ERI_LIST } from "src/url/Url";
import api from "src/redux/actions/apis";
import DataNotFound from "../DataNotFound/DataNotFound";
import SpinerLoader from "src/utils/SpinerLoader";
import { submitGAEvent } from "src/utils/GAEvents";
import portimg1 from "../../assets/RailCrossing/1.jpg";
import portimg2 from "../../assets/RailCrossing/2.jpg";
import portimg3 from "../../assets/RailCrossing/3.jpg";
import { Card } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa"; // FontAwesome Info Circle icon
import { DateTimeFormateERI } from "../../utils/DataFormate";
import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CCardSubtitle,
  CCardText,
  CButton,
  CTableRow,
  CTooltip,
} from "@coreui/react";
import moment from "moment";

function ERITable() {
  const {
    eri_select_shipping_line,
    eri_select_shipping_terminal,
    eri_select_shipping_window,
    eri_party_information,
    eri_facility_name,
    eri_facility_type,
    eri_code,
    eri_port,
    eri_address,
    eri_time,
    eri_notes,
    eri_has_pending_reviews,
  } = languageJson.ERI_Value;

  const timeWindowList = [
    { id: "First Shift", value: "First Shift" },
    { id: "Second Shift", value: "Second Shift" },
  ];

  let tableHeaderValue = [
    "Shipping Line",
    "Facility Code",
    "20' STD",
    "20' RF",
    "20' FR",
    "20' OT",
    "40' STD",
    "40' RF",
    "40' HC",
    "40' FR",
    "40' OT",
    "45' HC",
    "SP EQP",
  ];
  let tableHeaderValues = [
    "20' STD",
    "20' RF",
    "20' FR",
    "20' OT",
    "40' STD",
    "40' RF",
    "40' HC",
    "40' FR",
    "40' OT",
    "45' HC",
    "SP EQP",
  ];

  const [list, setList] = useState(null);
  const [initList, setInitList] = useState(null);
  const [paginatedData, setPaginatedData] = useState(null);
  const [shippingLine, setShippingLine] = useState("");
  const [allShippingLines, setAllShippingLines] = useState([]);
  const [allDataTerminals, setAllDataTerminals] = useState([]);
  const [terminal, setTerminal] = useState("");
  const [timeWindow, setTimeWindow] = useState("First Shift");
  const [isSearch, setIsSearch] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // Current page number
  const [totalPages, setTotalPages] = useState(0); // Current page number
  const [pageSize, setPageSize] = useState(10); // Current page number
  const [size, setSize] = useState(1);
  const [isHoveredId, setIsHoveredId] = useState(null);
  const [hoverInfo, setHoverInfo] = useState(null);
  const [lastModified, setlastModified] = useState(null);
  const handleMouseEnter = (e, dataItem, childItem) => {
    const startTime = moment(childItem.startTime).format("MM/DD/YYYY hh:mm A");
    const endTime = moment(childItem.endTime).format("MM/DD/YYYY hh:mm A");
    const timeModified = startTime + " - " + endTime;

    const facilityAddress = dataItem.party.facilityAddress;
    const addressData = JSON.parse(facilityAddress);
    const formattedAddress = [
      addressData.Address,
      addressData.City,
      addressData.State,
      addressData.Country,
      addressData.Zip,
    ]
      .filter(Boolean)
      .join(", ");
    setIsHoveredId(dataItem?.id);
    setHoverInfo({
      facilityName: dataItem?.party?.name,
      facilityType: dataItem?.party?.facilityType,
      code: dataItem?.party?.code,
      port: dataItem?.party?.port,
      address: formattedAddress,
      time: timeModified,
      notes: childItem?.notes || "N/A",
      hasPendingReviews: childItem.hasPendingReviews === true ? "Yes" : "No",
    });
    e.stopPropagation();
  };

  const handleMouseLeave = (e) => {
    setTimeout(() => {
      setIsHoveredId(null);
      setHoverInfo(null);
    }, 100); // delay in ms
    e.stopPropagation();
  };

  useEffect(() => {
    submitGAEvent("ERI");
  }, []);

  const getEriList = async () => {
    try {
      setIsSearch(true);
      await api.get(GET_DATAHUB_ERI_LIST).then((res) => {
        const { customcode, data } = res.data;
        if (customcode === 200) {
          setIsSearch(false);
          const shippingExist = new Set();
          const terminalExist = new Set();
          let shippingArray = [];
          let terminalArray = [];
          let tableDataArray = [];
          let sortingLastModified = data?.sort(
            (a, b) => new Date(b.lastModified) - new Date(a.lastModified)
          );
          setlastModified(
            data?.length > 0 ? sortingLastModified[0].lastModified : 0
          );
          data.forEach((item) => {
            item.partyTimeWindowCapacities.forEach((partyTimeWindowItem) => {
              partyTimeWindowItem.equipmentCapacities.forEach(
                (equipmentItem) => {
                  let equipmentItemObject = {
                    id: item.shippingLine.id,
                    name: item.shippingLine.name,
                    code: item.party.code,
                    description: partyTimeWindowItem.description,
                    hasPendingReviews: partyTimeWindowItem.hasPendingReviews,
                    startTime: partyTimeWindowItem.startTime,
                    endTime: partyTimeWindowItem.endTime,
                    blocked: equipmentItem.blocked,
                    capacity: equipmentItem.capacity,
                    changeReason: equipmentItem.changeReason,
                    dualOnly: equipmentItem.dualOnly,
                    equipmentSizeType: equipmentItem.equipmentSizeType,
                    open: equipmentItem.open,
                    pendingReview: equipmentItem.pendingReview,
                  };
                  tableDataArray.push(equipmentItemObject);
                }
              );
            });

            if (!shippingExist.has(item.shippingLine.name)) {
              shippingExist.add(item.shippingLine.name);
              shippingArray.push({
                id: item.shippingLine.id,
                name: item.shippingLine.name,
              });
            }

            if (!terminalExist.has(item.party.name)) {
              terminalExist.add(item.party.name);
              terminalArray.push({
                id: item.party.code,
                name: item.party.name,
              });
            }
          });
          setAllShippingLines(shippingArray);
          setAllDataTerminals(terminalArray);
          setInitList(data);
          setList(data);
          const totalPages = data && Math.ceil(data.length / pageSize);
          setTotalPages(totalPages);
          const paginatedData = data && data.slice(0, pageSize);
          setPaginatedData(paginatedData);
        } else {
          setIsSearch(false);
          setInitList([]);
          setList([]);
          setPaginatedData([]);
        }
      });
    } catch (err) {
      setIsSearch(false);
      console.log(err);
    }
  };

  useEffect(() => {
    getEriList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFacilityName = (e) => {
    const facilityName = e.target.value;
    setTerminal(facilityName);
    setIsSearch(true);
    const filteredData =
      initList &&
      initList
        .filter((item) => item !== null) // Remove null items if targetDate was applied
        .filter(
          (item) =>
            (!shippingLine ||
              item.shippingLine.name.toLowerCase() ===
                shippingLine.toLowerCase()) &&
            (!facilityName ||
              item.party.name.toLowerCase() === facilityName.toLowerCase())
        );
    setIsSearch(false);
    setList(filteredData);
    setCurrentPage(1); // Current page number
    const totalPages =
      filteredData && Math.ceil(filteredData.length / pageSize);
    setTotalPages(totalPages);
    const paginatedData = filteredData && filteredData.slice(0, pageSize);
    setPaginatedData(paginatedData);
  };

  const handleClickShippingLine = (e) => {
    const shippingNameValue = e.target.value;
    setShippingLine(e.target.value);
    setIsSearch(true);
    const filteredData =
      initList &&
      initList
        .filter((item) => item !== null) // Remove null items if targetDate was applied
        .filter(
          (item) =>
            (!shippingNameValue ||
              item.shippingLine.name.toLowerCase() ===
                shippingNameValue.toLowerCase()) &&
            (!terminal ||
              item.party.name.toLowerCase() === terminal.toLowerCase())
        );
    setIsSearch(false);
    setList(filteredData);
    setCurrentPage(1); // Current page number
    const totalPages =
      filteredData && Math.ceil(filteredData.length / pageSize);
    setTotalPages(totalPages);
    const paginatedData = filteredData && filteredData.slice(0, pageSize);
    setPaginatedData(paginatedData);
    e.target.blur(); // Remove focus so it closes immediately
  };

  const handleTimeWindow = (e) => {
    const timeWindowValue = e.target.value;
    setTimeWindow(timeWindowValue);
    let pageSizeNumber = 10;
    if (timeWindowValue === "") {
      pageSizeNumber = 5;
    }
    setPageSize(pageSizeNumber);

    const totalPages = list && Math.ceil(list.length / pageSizeNumber);

    const paginatedData =
      list &&
      list.slice(
        (currentPage - 1) * pageSizeNumber,
        currentPage * pageSizeNumber
      );
    setTotalPages(totalPages);
    setPaginatedData(paginatedData);
  };

  const paginationFun = (currentPageValue) => {
    const totalPages = list && Math.ceil(list.length / pageSize);
    const paginatedData =
      list &&
      list.slice(
        (currentPageValue - 1) * pageSize,
        currentPageValue * pageSize
      );
    setTotalPages(totalPages);
    setPaginatedData(paginatedData);
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      paginationFun(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      paginationFun(currentPage - 1);
    }
  };

  const ToolTipContent = () => {
    return (
      <CTableRow>
        <CTableHeaderCell colSpan={12} style={{ textAlign: "left" }}>
          <CCardSubtitle style={{ display: "flex", width: "100%" }}>
            {eri_party_information}
          </CCardSubtitle>
          <CCardText style={{ display: "flex", width: "100%" }}>
            <ul style={{ paddingLeft: "20px" }}>
              <li>
                <span
                  style={{
                    fontSize: "1.2em",
                    marginRight: "10px",
                  }}
                >
                  &#8226;
                </span>
                {eri_facility_name}:
                <span style={{ fontWeight: "100" }}>
                  {" "}
                  {hoverInfo?.facilityName}
                </span>
              </li>
              <li>
                <span
                  style={{
                    fontSize: "1.2em",
                    marginRight: "10px",
                  }}
                >
                  &#8226;
                </span>
                {eri_facility_type}:
                <span style={{ fontWeight: "100" }}>
                  {" "}
                  {hoverInfo?.facilityType}
                </span>
              </li>
              <li>
                <span
                  style={{
                    fontSize: "1.2em",
                    marginRight: "10px",
                  }}
                >
                  &#8226;
                </span>
                {eri_code}:
                <span style={{ fontWeight: "100" }}> {hoverInfo?.code}</span>
              </li>
              <li>
                <span
                  style={{
                    fontSize: "1.2em",
                    marginRight: "10px",
                  }}
                >
                  &#8226;
                </span>
                {eri_port}:
                <span style={{ fontWeight: "100" }}> {hoverInfo?.port}</span>
              </li>
              <li>
                <span
                  style={{
                    fontSize: "1.2em",
                    marginRight: "10px",
                  }}
                >
                  &#8226;
                </span>
                {eri_address}:
                <span style={{ fontWeight: "100" }}> {hoverInfo?.address}</span>
              </li>

              <li>
                <span
                  style={{
                    fontSize: "1.2em",
                    marginRight: "10px",
                  }}
                >
                  &#8226;
                </span>
                {eri_time}:
                <span style={{ fontWeight: "100" }}> {hoverInfo?.time}</span>
              </li>

              <li>
                <span
                  style={{
                    fontSize: "1.2em",
                    marginRight: "10px",
                  }}
                >
                  &#8226;
                </span>
                {eri_notes}:
                <span style={{ fontWeight: "100" }}> {hoverInfo?.notes}</span>
              </li>

              <li>
                <span
                  style={{
                    fontSize: "1.2em",
                    marginRight: "10px",
                  }}
                >
                  &#8226;
                </span>
                {eri_has_pending_reviews}:
                <span style={{ fontWeight: "100" }}>
                  {" "}
                  {hoverInfo?.hasPendingReviews}
                </span>
              </li>
            </ul>
          </CCardText>
        </CTableHeaderCell>
      </CTableRow>
    );
  };

  const renderAccordion = (dataItem, index) => (
    <React.Fragment key={index}>
      {dataItem.partyTimeWindowCapacities.map(
        (childItem, indexChildItem) =>
          (childItem.description === timeWindow || timeWindow === "") && (
            <CTableRow key={indexChildItem}>
              <CTableHeaderCell
                scope="row"
                style={{
                  textAlign: "left",
                  // padding: "20px",
                  alignContent: "space-around",
                }}
              >
                {dataItem.shippingLine.name}({dataItem.shippingLine.code})
                <button
                  style={{
                    marginLeft: "10px",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "blue",
                  }}
                >
                  <CTooltip
                    content={isHoveredId === dataItem?.id && <ToolTipContent />}
                    placement="right"
                    className={
                      isHoveredId === dataItem?.id ? "" : "hide-tooltip"
                    }
                  >
                    <CButton className="icon-button">
                      <FaInfoCircle
                        style={{ cursor: "pointer", fontSize: "24px" }}
                        onMouseEnter={(e) =>
                          handleMouseEnter(e, dataItem, childItem)
                        }
                        onMouseLeave={(e) => handleMouseLeave(e)}
                      />
                    </CButton>
                  </CTooltip>
                </button>
              </CTableHeaderCell>
              <CTableHeaderCell
                scope="row"
                style={{
                  textAlign: "center",
                  fontWeight: 100,
                  // padding: "20px",
                  alignContent: "space-around",
                }}
              >
                {dataItem.party.code}
              </CTableHeaderCell>
              {tableHeaderValues.map((type, idx) => {
                const matchingRow = childItem.equipmentCapacities.find(
                  (row) => row.equipmentSizeType === type
                );
                return (
                  <CTableDataCell
                    key={idx}
                    style={{
                      whiteSpace: "pre-line",
                      textAlign: "center",
                      padding: "15px",
                      fontWeight: 200,
                      alignContent: "space-around",
                      backgroundColor:
                        matchingRow.open === true ? "#659954" : "#c93332", // custom colors
                      color: "white", // optional: to make text color stand out on the background
                    }}
                  >
                    {matchingRow ? (matchingRow.open ? "Open" : "Closed") : "-"}
                  </CTableDataCell>
                );
              })}
            </CTableRow>
          )
      )}
    </React.Fragment>
  );

  return (
    <div>
      <Header />
      <div className="image-row-banner">
        <img className="banner_img" src={portimg1} alt="" />
        <img className="banner_img" src={portimg3} alt="" />
        <img className="banner_img" src={portimg2} alt="" />
      </div>
      <div className="vo-bg">
        <div className="container-fluid row py-4 ">
          <div>
            <Link to="/">
              {" "}
              <span className="vo-menu pe-2">
                {languageJson.home_txt}{" "}
              </span>{" "}
            </Link>
            <span className="text-dark ps-2">
              {" "}
              / &nbsp; {languageJson.empty_return_instructions}
            </span>
          </div>
        </div>
      </div>

      {/* ------------------------------------------------------ */}
      <div className="" style={{ marginTop: "-100px" }}>
        <section className="container py-5">
          <div className="row container-fluid py-5 tabVesselDiv">
            <div className="d-flex justify-content-center">
              <div className="truckTurnTimeMainDiv historicalTTTMainDiv">
                <div className="container">
                  <div className="titleDescpDiv">
                    <h2>{languageJson.empty_return_instructions}</h2>
                  </div>
                  <div className="col-12 lastUpdateDiv">
                    <div className="col-12 listOptionDiv">
                      <div
                        className="row"
                        style={{
                          display: "flex !important",
                          justifyContent: "space-evenly",
                          alignContent: "center",
                        }}
                      >
                        <div className="col-md-6 shipping-div-menu">
                          {" "}
                          <label
                            className="facility-lable"
                            style={{ marginBottom: "5px" }}
                          >
                            {eri_select_shipping_line}
                          </label>
                          <select
                            size={size}
                            onFocus={() => setSize(8)}
                            onBlur={() => setSize(1)}
                            selected={"All"}
                            onChange={(e) => handleClickShippingLine(e)}
                            className="browser-default custom-select shipping-select-menu"
                          >
                            <option value="">{languageJson.all_txt}</option>
                            {allShippingLines != null &&
                              Array.isArray(allShippingLines) &&
                              allShippingLines
                                .sort((a, b) => a.name.localeCompare(b.name)) // <-- This is the sorting part
                                .map((lineEle, index) => (
                                  <option value={lineEle.name} key={index}>
                                    {lineEle.name}
                                  </option>
                                ))}
                          </select>
                        </div>
                        <div className="col-md-6">
                          {" "}
                          <label className="facility-lable">
                            {eri_select_shipping_terminal}
                          </label>
                          <select
                            selected={"All"}
                            onChange={(e) => handleFacilityName(e)}
                            className="browser-default custom-select"
                          >
                            <option value="">{languageJson.all_txt}</option>
                            {allDataTerminals != null &&
                              allDataTerminals &&
                              allDataTerminals.map((terminal, index) => {
                                return (
                                  <option value={terminal.name} key={index}>
                                    {terminal.name}{" "}
                                  </option>
                                );
                              })}
                          </select>
                        </div>

                        <div className="col-md-5">
                          {" "}
                          <label className="facility-lable">
                            {eri_select_shipping_window}
                          </label>
                          <select
                            value={timeWindow}
                            onChange={(e) => handleTimeWindow(e)}
                            className="browser-default custom-select"
                          >
                            {timeWindowList.map((timeele, index) => {
                              return (
                                <option value={timeele.id} key={index}>
                                  {timeele.value}{" "}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {list && list !== null && list.length > 0 ? (
              <div className="col-md-12 lastUpdatedTxt ">
                <span
                  className="full-table-view"
                  style={{
                    fontSize: "16px",
                    display: "flex",
                    marginTop: "10px",
                    justifyContent: "flex-end",
                  }}
                >
                  {languageJson.last_updated_value_txt}:{" "}
                  {DateTimeFormateERI(lastModified)}
                </span>
              </div>
            ) : (
              <></>
            )}
          </div>
          {list && list !== null && list.length > 0 ? (
            <div className="allAlertsMainDiv full-table-view">
              <div className="eriDiv">
                <Card>
                  <Card.Body style={{ minWidth: "100%", overflow: "auto" }}>
                    <CTable bordered striped hover>
                      <CTableHead color="white">
                        <CTableRow></CTableRow>
                        <CTableRow style={{ textAlign: "center" }}>
                          {tableHeaderValue.map((header, headerIndex) => (
                            <CTableHeaderCell
                              key={headerIndex}
                              scope="col"
                              style={{
                                minWidth: headerIndex === 0 ? "200px" : "auto",
                                paddingTop: "20px",
                                paddingBottom: "20px",
                                backgroundColor: "#3e3e3e",
                                color: "white",
                              }}
                            >
                              {header.split("\n").map((line, i) => (
                                <div key={i}>{line}</div>
                              ))}
                            </CTableHeaderCell>
                          ))}
                        </CTableRow>
                      </CTableHead>
                      <CTableBody>
                        {paginatedData &&
                          paginatedData.map((item, index) => {
                            return renderAccordion(item, index);
                          })}
                      </CTableBody>
                    </CTable>
                  </Card.Body>
                </Card>
              </div>
            </div>
          ) : list && list !== null && list.length === 0 ? (
            <DataNotFound />
          ) : (
            isSearch && <SpinerLoader />
          )}

          {list && list !== null && list.length > pageSize ? (
            <div className="pagination-controls">
              <button
                className="btn btn-primary"
                onClick={prevPage}
                disabled={currentPage === 1}
              >
                {languageJson.LogisticsMap.preview_txt}
              </button>
              <span>
                {" "}
                Page {currentPage} of {totalPages}{" "}
              </span>
              <button
                className="btn btn-primary"
                onClick={nextPage}
                disabled={currentPage === totalPages}
              >
                {languageJson.LogisticsMap.next_txt}
              </button>
            </div>
          ) : (
            <></>
          )}
        </section>
      </div>
    </div>
  );
}

export default ERITable;
